import { InfoOutlined } from '@mui/icons-material';
import { Box, TextField as MuiTextField, type TextFieldProps as MuiTextFieldProps } from '@mui/material';
import { forwardRef } from 'react';

import { Tooltip } from '../Tooltip/Tooltip';

export type TextFieldProps = { infoTooltip?: string } & MuiTextFieldProps;

export const TextField = forwardRef<HTMLDivElement, TextFieldProps>(({ infoTooltip, ...rest }, ref) => {
  return infoTooltip ? (
    <Box display="flex" gap={1} width={rest.fullWidth ? '100%' : undefined}>
      <MuiTextField {...rest} ref={ref} />
      <Tooltip title={infoTooltip}>
        <InfoOutlined sx={{ marginTop: 1 }} />
      </Tooltip>
    </Box>
  ) : (
    <MuiTextField {...rest} ref={ref} />
  );
});

TextField.displayName = 'TextField';
